import { EventBus } from '@/services/globalEventBus';

export default new EventBus();

export const events = {
  MODAL_OPEN: 'modal-open',
  END_GET_DESCRIPTION: 'end-get-description',
  SET_USER_POSITION: 'set-user-position',
};
